import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_TICKDUPLICATA_SCHEMA_LITERAL = {
    title: 'Schéma Duplicata',
    description: 'Duplicata',
    version: 0,
    keyCompression: false,
    primaryKey: 'DUP_PIECE_INTERNAL',
    type: 'object',
    properties: {
        DUP_PIECE_INTERNAL : { type : 'string', maxLength : 100 },
        MD_SITEGID : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSE_LIB : { type : 'string' },
        MD_CAISSIERGID : { type : 'string' },
        MD_CAISSIER_LIB : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        MD_LOCALGID : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        DUP_DATE : { type : 'string' },
        DUP_DATE_UTC : { type : 'string' },
        DUP_NUMIMP : { type : 'number', default : 0 },
        DO_PIECE_INTERNAL : { type : 'string' },
        DO_TYPE_OP : { type : 'string' },
        DO_DATE : { type : 'string' },
        DUP_MOTIF : { type : 'number' },
        DUP_MOTIF_LIB : { type : ['string', 'null'] },
        DUP_MOTIF_AUTRE : { type : ['string', 'null'] },
        CLU_APP_VERSION : { type : ['string', 'null'] },
        DUP_PIECE_INTERNAL_PREVIOUS : { type : ['string', 'null'] },
        DUP_SIGNATURE_OFFLINE : { type : ['number', 'null'] },
        DUP_SIGNATURE_DATETIME : { type : ['string', 'null'] },
        DUP_SIGNATURE_REPORT : { type : ['number', 'null'] },
        DUP_SIGNATURE : { type : ['string', 'null'] },
        DUP_SIGNATURE_PREVIOUS : { type : ['string', 'null'] },
        DUP_SIGNATURE_DATA : { type : ['string', 'null'] },
        ZSYNCUP_FLAG  : { type : 'number', default : 0 },
        ZSYNCUP_STATUS  : { type : 'string' },
        ZSYNCUP_ERROR_MESSAGE  : { type : 'string' },
        ZSYNCUP_DATETIME  : { type : 'string' },
        ZSYNCUP_FEEDID  : { type : 'string' }
    },
    required: [ 'DUP_PIECE_INTERNAL', 'DO_PIECE_INTERNAL', 'DUP_DATE_UTC', 'DO_DATE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_TICKDUPLICATA_SCHEMA_LITERAL);
export type RxCluTickDuplicataDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_TICKDUPLICATA_SCHEMA: RxJsonSchema<RxCluTickDuplicataDocumentType> = CLU_TICKDUPLICATA_SCHEMA_LITERAL;
